/* eslint-disable max-len */
import copyToClipboard from "./copy-to-clipboard";
import getSnippetElements from "./get-snippet-elements";

/**
 * Converts embed snippet into fallback message when
 * no support for experience
 *
 * @returns {undefined}
 */
export default function createFallback() {
  const { convo, link } = getSnippetElements();
  const fallback = document.createElement("div");
  fallback.classList.add("fallback");
  const message = [
    "<p>Sorry, your browser doesn't support our embedded experience. We support modern versions of all major browsers.</p>"
  ];

  if (/android/i.test(navigator.userAgent)) {
    message.push("<p>Paste the URL into Chrome and try again.</p>");
  }

  if (/ipad|iphone|ipod/i.test(navigator.userAgent)) {
    message.push("<p>Paste the URL into Safari and try again.</p>");
  }

  // eslint-disable-next-line quotes
  message.push('<p><button class="copy">Copy the URL</button></p>');

  fallback.innerHTML = message.join("");
  convo.appendChild(fallback);
  convo.removeChild(link);

  const button = convo.querySelector(".copy");
  button.addEventListener("click", (event) => {
    event.preventDefault();
    copyToClipboard(location.href);
  });
}
